import React, { useCallback } from "react";
import { addTimeSpanToVideoUrl, handlePauseAllVideo, secondToHour } from "../../../utils";
import Styles from './styles.module.css';
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { useState } from "react";

export default function VidexBox({ ques, data }) {
  const randomNumber = Math.random() * 10;
  const dispatch = useDispatch();
  const { updateDeclinedAnsweredForEditor } = bindActionCreators(Actions, dispatch);

 const searchState = useSelector((state) => state.search);
  const [question, setQuestion] = useState(ques);
  const [answer, setAnswer] = useState(data[0])
  // const [startTime,setStartTime]=React.useState(data.answers[0].startTime);
  // const [endTime,setEndTime]=React.useState(data.answers[0].endTime);
  const editorState = useSelector(state => state.editor);
  const container = {
    width: '100%',
    display: 'flex',
    // alignItems:'baseline',
    justifyContent: 'center',
  }
  const videoContainer = {
    width: '75%',
    borderRight: '1.5px solid',
    borderImage: 'linear-gradient(90deg, #00D1FF 0%, #BD00FF 15.98%, #0075FF 29.15%, #00E0FF 43.18%) 1'
  }
  const stampContainer = {
    width: '23%',
    marginLeft: '2%'
  }
  const ansStyles = {
    // marginTop: "10px",
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "300",
    marginBottom: '10px',
    // borderBottom:' 1px solid #2A364A'
  };
  const contentStyle = {
    border: "1px solid #E0E2E6",
    borderRadius: "16px",
    boxShadow: "0px 4px 16px 0px #1018280F",
    width: '95%'
  };
  const showMoreStyles = {
    fontSize: "14px",
    color: "#F59B00",
    lineHeight: "20px",
    fontWeight: "500",
    cursor: "pointer",
    marginTop: "5px",
  };
  const showMoreSelectedStyles = {
    fontSize: "12px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "400",
    background:
      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    "-o-text-fill-color": "transparent",
    cursor: "pointer",
    marginTop: "5px",
  };
  // const onClickTimeSpan = (id, answerObj) => {
  //   // advanceFilterModalToggle({ bool: false, value: "" });
  //   console.log("answer obj",answerObj)
  //   let videoElem = document.querySelectorAll("video");
  //   for (let i = 0; i < videoElem.length; ++i) {
  //     document.getElementById(videoElem[i].id).pause();
  //   }
  //   let objIndex = searchState.searchData.findIndex(
  //     (obj) => obj.questionUuid === id
  //   );
  //   let objDeclineIndex = editorState.declinedData.findIndex(
  //     (obj) => obj.questionUuid === id
  //   );
  //   setQuestion(answerObj);
  //     setAnswer(answerObj.answers[0]);
  
  //   setTimeout(() => {
  //     document.getElementById(answerObj?.questionUuid)?.load();
  //     document.getElementById(answerObj?.questionUuid)?.play();
  //   }, 1000);
  // };
  const onClickTimeSpan = useCallback((id, answerObj) => {
    // console.log("answer obj", answerObj);
    
    // Pause all video elements
    let videoElem = document.querySelectorAll("video");
    videoElem.forEach(video => document.getElementById(video.id)?.pause());

    // Find indices in searchState and editorState
    let objIndex = searchState.searchData.findIndex(obj => obj.questionUuid === id);
    let objDeclineIndex = editorState.declinedData.findIndex(obj => obj.questionUuid === id);
    let shallowCopy = [...editorState.declinedData];
    let quesIndex = shallowCopy.findIndex((ques) => ques.questionUuid === id);
     shallowCopy.splice(quesIndex, 1, answerObj);
    // Set question and answer
    updateDeclinedAnsweredForEditor(shallowCopy)
    setQuestion(answerObj);
    setAnswer(answerObj.answers[0]);

   
    //  console.log("shallowCopy", shallowCopy)
    // Load and play the video after a delay
    setTimeout(() => {
      const videoElement = document.getElementById(answerObj?.questionUuid);
      videoElement?.load();
      videoElement?.play();
    }, 1000);
}, [searchState.searchData, editorState.declinedData]);

  const onClickTimeStamp = (quesId, suggest, startTime,endTime) => {
    // console.log('timse stamp',startTime,startTime);
    //  setStartTime(startTime);
    //  setEndTime(endTime)
    setAnswer(suggest)
    let shallowCopy = [...editorState.declinedData];
    let quesIndex = shallowCopy.findIndex((ques) => ques.questionUuid === quesId);
    shallowCopy.splice(quesIndex, 1, suggest);
    // console.log("shallowCopy", shallowCopy)
    updateDeclinedAnsweredForEditor(shallowCopy)
    setTimeout(() => {
      document.getElementById(`${suggest.questionUuid}_${suggest.questionUuid}`)?.load();
      document.getElementById(`${suggest.questionUuid}_${suggest.questionUuid}`)?.play();
      document.getElementById(`${suggest.questionUuid}_${suggest.questionUuid}`)?.focus();
    }, 1000);
  }
  
const stylesTimeStamp=(time)=>{
  if(Array.isArray(answer)){
     if(time===answer[0].startTime) {
      return showMoreStyles}
       else {
        return showMoreSelectedStyles
  }
}
if(!Array.isArray(answer)){

}
}

  return (
    <>
    {/* <div className="mt-2" style={container} >
      {ques.videoAttachmentURL.length !== 0 && <div style={videoContainer}>
        <video
          id={`${ques.questionUuid}_${ques.questionUuid}`}
          controls
          onBlur={() => handlePauseAllVideo()}
          style={contentStyle}
        >
          <source
         src={`${ques?.videoAttachmentURL[0]?.objectUrl}#t=${data[0]?.startTime},${data[0]?.endTime}`}
            type="video/mp4"
          />
        </video>
      </div>}
      <div style={stampContainer}>
        <div style={ansStyles}>Timestamps</div>
        {ques.suggestions.map(suggest=>{
       console.log('check time',suggest)
            return(
                <div key={suggest.id} className={Styles.stamp}>
                    <p onClick={()=>onClickTimeStamp(ques.questionUuid, suggest,suggest.answers[0].startTime,suggest.answers[0].endTime)} style={suggest.answers[0].startTime === startTime ?showMoreStyles:showMoreSelectedStyles}>
                      {secondToHour(suggest.answers[0].startTime)}-{secondToHour(suggest.answers[0].endTime)}
                      </p>
                </div>
            )
        })}
     

      </div>
    </div> */}



    <div className="mt-2" style={container} >
    {question.videoAttachmentURL.length !== 0 && <div style={videoContainer}>
        <video
          onBlur={() => handlePauseAllVideo()}
          controls
          id={question.questionUuid}
          style={contentStyle}
          
        >
         <source src={addTimeSpanToVideoUrl( question?.videoAttachmentURL[0]?.objectUrl, answer?.startTime, answer?.endTime)}
                  type="video/mp4"
                />
        </video>
      </div>
      }
       <div style={stampContainer}>
        <div style={ansStyles}>Timestamps</div>
        {question.suggestions &&
                    question.suggestions.map((time) => {
                      return (
                        <div key={time.id} className={Styles.stamp}>
                        <p
                          onClick={() =>
                            onClickTimeSpan(question.questionUuid, time,)
                          }
                          style={time.answers[0].startTime === answer?.startTime ?showMoreStyles:showMoreSelectedStyles}
                          // title={time.answers[0].answerText}
                        >
                          {secondToHour(time.answers[0].startTime)} - {secondToHour(time.answers[0].endTime)}
                        </p>
                        </div>
                      );
            })}
       
      </div>
    {/* {question.videoAttachmentURL[0] && (
            <div
              className=""
              style={videoContainer}
            >
              <video
                
                controls
                id={question.questionUuid}
                style={contentStyle}
                // onBlur={()=>handlePauseAllVideo()}
              >
                <source
                  src={addTimeSpanToVideoUrl(
                    question?.videoAttachmentURL[0]?.objectUrl,
                    answer?.startTime,
                    answer?.endTime
                  )}
                  type="video/mp4"
                />
              </video>
            
                
              { <div className="videotimesuggestions ms-2">
                <div className="videotimespan">
                  {question.suggestions &&
                    question.suggestions.map((time) => {
                      return (
                        <p
                          onClick={() =>
                            onClickTimeSpan(question.questionUuid, time)
                          }
                          className="videotimespan"
                          title={time.answers[0].answerText}
                        >
                          {secondToHour(time.answers[0].startTime)} - {secondToHour(time.answers[0].endTime)}
                        </p>
                      );
                    })}
                </div>
              </div>
              }
    </div>
    )}; */}
    </div>
    </>
  );
}
